module.exports = __webpack_public_path__ + "img/rain-drop.283588d5.svg";